/*
* Copyright (C) Regione Lombardia
*/
import { Pipe, PipeTransform } from '@angular/core';
import { specialCharacters } from '@core/utilities';

@Pipe({
    name: 'specialCharacters',
})
export class UtilitiesSpecialCharactersPipe implements PipeTransform {

    transform(text: string) {
        return specialCharacters(text);
    }

}
